module.exports = __webpack_public_path__ + "img/pasted imagess 0.0e70d5c2.png";